import { render, staticRenderFns } from "./z-aside.vue?vue&type=template&id=01f5d22e&scoped=true&"
import script from "./z-aside.vue?vue&type=script&lang=js&"
export * from "./z-aside.vue?vue&type=script&lang=js&"
import style0 from "./z-aside.vue?vue&type=style&index=0&id=01f5d22e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f5d22e",
  null
  
)

export default component.exports